// extracted by mini-css-extract-plugin
export default {"sendToMessenger":"_1KExr7SRQLYi8e8vPe6Vvi","branch-name":"xxCzXCVAqxZqxv8hSaqjx","branchName":"xxCzXCVAqxZqxv8hSaqjx"};